<template lang="pug">
  #postalForm
    v-layout(row justify-center)
      v-dialog(v-model="dialog" persistent max-width="850")
        v-card.py-5
            p.headline.text-xs-center ¿Estás seguro de que quieres crear el contexto {{contextToCreate}}?
            //v-card-text xxxxxx
            v-spacer.mt-4
            v-layout.px-5
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.purple-btn.bold(@click.native="dialog = false") CANCELAR
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.purple-btn.bold(@click.native="createContext()") CREAR CONTEXTO
    v-container(fluid)
      v-form
        v-layout.py-3(row wrap justify-space-around)
          v-flex(d-flex xs2)
            v-text-field(
              :v-model="folio"
              label="Folio"
              :value="folio"
              disabled
            )
          v-flex(d-flex xs6)
            v-select(
            :items="contexts"
            ref="contexto"
            autocomplete
            v-model="context"
            item-text="context"
            item-value="contextId"
            return-object
            label="Contexto"
            placeholder="Selecciona el contexto"
            )
              template(slot="selection" slot-scope="data")
                p {{data.item.context}} - {{data.item.contextId}}
              template(slot="item" slot-scope="data")
                v-list-tile-content(v-text="data.item.context")
                p &nbsp;&nbsp;
                v-list-tile-content(v-text="data.item.contextId")

          v-flex(xs1)
            v-btn.add-context( @click="addContext()" dark fab small )
              v-icon(dark) add
          v-flex( v-if='showAddContext' xs6)
            v-text-field(
              v-model="contextToCreate"
              label="Contexto nuevo"
            )
          v-flex.color-input( v-if='showAddContext' xs2)
            input(
              v-model="newContextColor"
              type="color"
            )
          v-flex( v-if='showAddContext' xs4)
            v-btn.context-btn(flat @click="openDialog") Crear contexto

          v-flex.pr-2(d-flex xs6)
            v-text-field(
              v-model="aggressionDateTime"
              label="Fecha de agresión"
              data-vv-name="name"
              required
              return-masked-value
              mask="date-with-time"
              hint="DD/MM/AAAA HH:MM"
            )
          v-flex.pl-2(d-flex xs6)
            v-text-field(
              v-model="verificationDateTime"
              label="Fecha de verificación"
              data-vv-name="fecha"
              required
              return-masked-value
              mask="date-with-time"
              hint="DD/MM/AAAA HH:MM"
            )
        v-layout.py-3(row wrap justify-space-between)
          v-flex.pr-2(d-flex xs6)
            v-select(
            :items="states"
            ref="Entidad"
            autocomplete
            v-model="state"
            label="Entidad"
            placeholder="Selecciona la entidad"
            )
          v-flex.pl-2(d-flex xs6)
            v-select(
            :items="municipalities"
            ref="Municipio"
            autocomplete
            v-model="municipality"
            label="Municipio"
            placeholder="Selecciona el municipio"
            )
        v-layout.py-3.px-0(row wrap)
          v-text-field(
            v-model="alertLink"
            ref="Link de la alerta"
            label="Link de la alerta"
          )
        v-layout.py-3.px-0(row wrap)
          v-select(
            :items="typesOfAggression"
            autocomplete
            multiple
            v-model="aggressionType"
            label="Tipo de agresión"
            placeholder=""
            )
        v-layout.py-3.px-0(row wrap)
          v-select(
            :items="subtypesOfAggression"
            autocomplete
            multiple
            v-model="aggressionSubtype"
            label="Subtipo de agresión"
            placeholder=""
          )
        v-layout.py-3.px-0(row wrap)
          v-text-field(
            v-model="details"
            ref="Más información"
            label="Más información"
            required
            multi-line
          )
</template>

<script>
import $mx from "../services/mx.service.js";

export default {
  name: "PostalForm",
  props: {},
  data() {
    return {
      folio: this.$store.state.record.folio,
      states: $mx.getStates().sort(),
      showAddContext: false,
      dialog: false,
      contextToCreate: "",
      newContextColor: "#000000",
      contextId: "",
      contextIdExists: undefined
    };
  },
  computed: {
    record() {
      return this.$store.getters.record;
    },
    contexts() {
      return this.$store.state.contexts;
    },
    context: {
      get() {
        return this.$store.state.record.context;
      },
      set(value) {
        this.$store.state.record.context = value;
      }
    },
    aggressionDateTime: {
      get() {
        return this.$store.state.record["aggression_datetime"];
      },
      set(value) {
        this.$store.commit("updateAggressionDateTime", value);
      }
    },
    verificationDateTime: {
      get() {
        return this.$store.state.record["verification_datetime"];
      },
      set(value) {
        this.$store.commit("updateVerificationDateTime", value);
      }
    },
    municipality: {
      get() {
        return this.$store.state.record.municipality;
      },
      set(value) {
        this.$store.commit("updateMunicipality", value);
      }
    },
    state: {
      get() {
        return this.$store.state.record.state;
      },
      set(value) {
        this.$store.commit("updateState", value);
      }
    },
    alertLink: {
      get() {
        return this.$store.state.record["alert_link"];
      },
      set(value) {
        this.$store.commit("updateAlertLink", value);
      }
    },
    aggressionType: {
      get() {
        return this.$store.state.record["aggression_type"];
      },
      set(value) {
        this.$store.commit("updateAggressionType", value);
      }
    },
    aggressionSubtype: {
      get() {
        return this.$store.state.record["aggression_subtype"];
      },
      set(value) {
        this.$store.commit("updateAggressionSubtype", value);
      }
    },
    details: {
      get() {
        return this.$store.state.record.details;
      },
      set(value) {
        this.$store.commit("updateDetails", value);
      }
    },
    typesOfAggression() {
      const typeNames = this.$store.state.aggressionsTypes.map(type => {
        return type.title;
      });
      return typeNames;
    },
    subtypesOfAggression() {
      if (!this.$store.state.record["aggression_type"]) return [];
      else {
        const subtypeNames = [];
        const typeHeader = this.$store.state.aggressionsTypes.filter(type => {
          return (
            this.$store.state.record["aggression_type"].indexOf(type.title) >= 0
          );
        });
        typeHeader.forEach(types => {
          types.subtypes.forEach(sub => {
            subtypeNames.push(sub.title);
          });
        });
        return subtypeNames;
      }
    },
    municipalities() {
      if (!this.state) return [];
      else {
        return $mx.getMuns(this.state).sort();
      }
    }
  },
  methods: {
    addContext() {
      this.showAddContext = !this.showAddContext;
    },
    createContextId() {
      console.log(this.contextToCreate, "CREATE");
      let identifier = this.contextToCreate
        .split(" ")
        .map(word => word[0])
        .join("")
        .toUpperCase();
      this.contextId = identifier;
    },
    openDialog() {
      if (this.contextToCreate) {
        this.createContextId();
        const contextIdExists = this.contexts.some(
          c => c.contextId == this.contextId
        );
        if (!contextIdExists) {
          this.dialog = true;
        } else {
          this.$notify({
            group: "foo",
            type: "error",
            title: "ERROR",
            text: "Las inciales del contexto ya existen."
          });
        }
      } else {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "El contexto se encuentra vacío."
        });
      }
    },
    async createContext() {
      try {
        let response = await this.$store.dispatch("createContext", {
          field: this.contextToCreate,
          fieldId: this.contextId,
          color: this.newContextColor
        });
        this.dialog = false;
        this.contextToCreate = "";
        this.showAddContext = false;
        this.$notify({
          group: "foo",
          type: "success",
          title: "ÉXITO",
          text: response.data.message
        });
      } catch (error) {
        console.log(error, "error");
      }
      this.updateContextsCsv();
      this.getContexts();
    },
    getContexts() {
      this.$store.dispatch("getContexts");
    },
    updateContextsCsv() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("updateContextsCsv")
          .then(response => {
            this.$store.commit("SET_UPDATECONTEXTSCSV_SUCCESS", {
              pending: false,
              statusCode: response.status
            });
            return resolve("ok");
          })
          .catch(error => {
            this.$store.commit("SET_UPDATECONTEXTSCSV_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            return reject("error");
          });
      });
    },
  }
};
</script>

<style scoped lang="scss">
.input-group.input-group--dirty.input-group--required.input-group--text-field.primary--text {
  width: 150px;
}
#postalForm {
  .add-context {
    background-color: #462979;
    width: 39px;
    height: 39px;
  }
  .context-btn {
    color: #462979;
    font-weight: 600;
    text-transform: none;
  }
  .color-input {
    align-self: center;
    text-align: center;
  }
}
</style>
